// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2m9uD","signatureBlock":"Footer_signatureBlock__1kfjq","signature":"Footer_signature__sEann"};